module.exports = __webpack_public_path__ + "img/msteam-addin-02.966738c1.png";